import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { selectedBranchAtom, authTokenAtom, lastTransactionAtom } from '../state/atoms'
import { useExchange } from './useExchange'

/**
 * Hook to automatically load exchange rates when branch changes
 * Use this in App.tsx to enable auto-loading
 */
export function useExchangeRatesAutoload() {
  const selectedBranch = useRecoilValue(selectedBranchAtom)
  const authToken = useRecoilValue(authTokenAtom)
  const lastTransaction = useRecoilValue(lastTransactionAtom)
  const { loadExchangeRates } = useExchange()

  // 거래 등록 후 '새 거래'로 초기화하기 전까지는 환율을 고정 (#4)
  const isTransactionActive = lastTransaction.transactionData !== null

  useEffect(() => {
    // Only load exchange rates if we have both a branch AND a valid token
    if (!selectedBranch || !authToken) {
      if (selectedBranch && !authToken) {
        console.warn('⚠️  Skipping exchange rate load: branch selected but no auth token')
      }
      return
    }

    if (isTransactionActive) {
      console.log('⏸️  거래 진행 중 - 환율 자동 갱신 일시 중지')
      return
    }

    console.log('Auto-loading exchange rates for branch:', selectedBranch.nid, 'with token:', authToken.substring(0, 10) + '...')
    loadExchangeRates(selectedBranch.nid)

    // 1분마다 자동 갱신
    const interval = setInterval(() => {
      console.log('⏰ Auto-refreshing exchange rates...')
      loadExchangeRates(selectedBranch.nid)
    }, 60000)

    return () => clearInterval(interval)
  }, [selectedBranch?.nid, authToken, loadExchangeRates, isTransactionActive])
}
